<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row>
          <b-col>
            <h4>{{ $t('nav.project_tags_list_title') }}</h4>
          </b-col>
          <b-col md="auto">
            <b-button-group>
              <b-button v-if="!loading && list.actions && list.actions.create" class="mb-3" variant="primary" @click="createForm=true;createFormId=null;">
                {{ $t('project_tag.create_new') }}
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-input-group>
                <b-form-input :placeholder="$t('global.search')" v-model="filters.search"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary" @click="getData()"><i class="fa fa-search"/></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <!-- <b-col md="auto" >
            <b-form-group label-cols :label="$dt('global.per_page', 'Per page:')">
                <b-form-select :options="[2,10,20,50,100,500]" v-model="filters.per_page" />
            </b-form-group>
          </b-col> -->
          <!-- <b-col md="auto" v-if="listPaginator.last_page > 1" >
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
          </b-col> -->
        </b-row>
        <ProjectTagForm v-if="createForm && createFormId===null" :id="createFormId" :project_id="projectId"
          @saved="createForm=false;createFormId=null; getData(); "
          @cancel="createForm=false;createFormId=null;" />
        <div v-if="loading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-row>
            <b-col>
              <NoDataView v-if="!tableItems.length"/>
              <b-table v-else class="table-sm text-center" responsive outlined hover head-variant="light"
                  :no-local-sorting=true
                  :sort-by.sync="filters.sort_field"
                  :sort-desc.sync="filters.sort_order"
                  :fields="tableFields"
                  :items="tableItems"
                  >
                <template v-slot:cell(color)="row">
                  <span :style="`color:${row.item.color}`"><i class="fa fa-circle mr-1"></i></span>{{row.item.color}}
                </template>
                <template v-slot:cell(hide)="row">
                  <b-form-checkbox :checked="row.item.hide" disabled />
                </template>
                <template v-slot:cell(options)="row">
                  <div class="flex-container options-center">
                  <a href="#" v-if="row.item.actions.update" v-on:click.prevent="row.toggleDetails">
                    <i :class="['mx-1 fa fa-edit fa-lg',{'text-warning': row.detailsShowing}]"/>
                  </a>
                  <Delete v-if="row.item.actions.delete"  :id="row.item.id" @deleted="getData" :deleteFn="()=>{return deleteFn(projectId, row.item.id)}" />
                  </div>
                </template>
                <template #row-details="row">
                  <div class="text-left">
                    <ProjectTagForm :id="row.item.id" :project_id="projectId"
                      @saved="row.toggleDetails(); getData(); "
                      @cancel="row.toggleDetails" />
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import NoDataView from '@/views/Shared/NoDataView.vue';
import Delete from '@/views/Shared/ModalDelete';
import Services from '@/services/index';
import { mapGetters, mapActions, mapState } from 'vuex';
import ProjectTagForm from '@/views/ProjectTags/ProjectTagForm';

export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      tableFields: [
        { key: 'tag.id', sortable: true, label: this.$t('global.id') },
        { key: 'color', sortable: true, label: this.$t('project_tag.color') },
        { key: 'hide', sortable: true, label: this.$dt('project_tag.hide', 'Hide Tag') },
        { key: 'tag.name', sortable: true, label: this.$t('project_tag.tag.name') },
        // { key: 'created_at', sortable: true, label: this.$t('global.created_at') },
        // { key: 'updated_at', sortable: true, label: this.$t('global.updated_at') },
        { key: 'options', label: this.$t('global.options') }
      ],
      filters: {
        sort_field: null,
        sort_order: null,
        search: '',
        notpaginate: 1,
      },
      loading: false,
      list: {},
      createForm: false,
      createFormId: null,
    };
  },
  props: {
    project_id: {
      type: Number,
      required: true
    },
  },
  components: {
    NoDataView, Delete, ProjectTagForm
  },
  computed: {
    tableItems() {
      return this.list.data || [];
    },
    params() {
      return {
        ...this.filters,
        sort_order: this.filters.sort_order ? 'desc' : 'asc'
      };
    },
    ...mapState('Auth', ['activeProjectId']),
    projectId() { return this.project_id || this.activeProjectId; },
  },
  watch: {
    page: 'getData',
    filters: { deep: true, handler: 'getData' },
  },
  methods: {
    getData() {
      this.loading = true;
      Services.projectTags.list(this.projectId, this.params).then(({ data }) => {
        this.list = data;
        this.loading = false;
      }).catch((err) => { this.loading = false; console.log(err); });
    },
    onPageChange(page) {
      page = page || this.page;
      if (page !== this.page) this.$router.push({ name: 'ProjectTags', params: { page } });
    },
    deleteFn(projectId, id) {
      return Services.projectTags.delete(projectId, id);
    }
  }
};
</script>

<style scoped>
</style>
